
import { Component, Vue } from 'vue-property-decorator'
import AppendixDialog from '@/views/orderManage/template/AppendixDialog.vue'
import AppendixName from '@/components/AppendixName/index.vue'
import {
    AppendixFileDto,
    DictDataDto,
    getSyDictDataInfo,
    GoodsListOfCategoryFormatDto,
    SelectGoodsOptionsDto
} from '@/api/commonConfig'
import dayjs from 'dayjs'
import { Action, Getter } from 'vuex-class'
import { addPurchaseOrder, purchaseOrderAgainAppApi } from '@/api/order'
import math from '@/core/math'
import { getCompanyAddressInfo } from '@/api/buyCar'
import BuyCarDialog from '@/views/orderManage/template/BuyCarDialog.vue'

@Component({
    name: 'ValetOrder',
    components: {AppendixDialog, AppendixName, BuyCarDialog}
})
export default class ValetOrder extends Vue {
    @Getter companyId!: string
    @Getter selectList!: SelectGoodsOptionsDto[]
    @Action setSelectList!: (val: SelectGoodsOptionsDto[]) => void

    showWayPicker = false
    showCalendar = false
    minDate = new Date()
    maxDate = new Date(dayjs().add(10, 'year').format('YYYY-MM-DD')) // 默认10年后
    isEdit = false

    params = {
        companyId: '',
        customerId: '',
        customerName: '',
        customerLever: '',
        customerLeverName: '',
        // （1商家下单 2代客下单）
        orderType: 2,
        // 1未付款 2已付款
        payStatus: '',
        deliveryDate: '',
        receiveAddress: '',
        receiveAddressName: '',
        receiveAddressDtl: '',
        receiveMobile: '',
        receiveMan: '',
        orderFileList: [],
        orderRemark: '',
        payFreight: 0,
        distributionWay: null,
        distributionWayDec: '',
        // 商品列表
        purchaseOrderDtlList: [],
        isDefault: 1,
        orderDtlList: [] // 后端返回商品列表数据，接收一下，然后会删除掉
    }
    distributionWayList = []

    selectGoodsList: GoodsListOfCategoryFormatDto[] = []
    totalPrice = 0 // 商品总金额

    placeType = '' // '2'为再来一单
    orderId = ''
    currRouteId = ''

    clickIndex = 0

    activated () {
      console.log(123456)
      console.log(this.$route.query)
        if (this.$route.query.fromPath === '1') {
            this.getCustomerInfo()
        } else if (this.$route.query.fromPath === '2') {
            this.totalPrice = Number(this.$route.query.totalPrice as string)
            this.selectGoodsList = this.selectList
        //  意外终止代客下单页面之后再从代客下单入口进去时
        }else if (this.$route.query.fromPath === '3') {
            this.getCustomerInfo()
        }
      if (this.$route.query.placeType === '2') {
        // 再来一单
        this.orderId = this.$route.query.orderId as string
        this.currRouteId = this.$route.query.currRouteId as string
        this.getPurchaseOrderAgain()
      }
    }

    created () {
        this.params.companyId = this.companyId
        this.placeType = this.$route.query.placeType as string
        if (this.placeType === '2') {
            // 再来一单
            this.orderId = this.$route.query.orderId as string
            this.currRouteId = this.$route.query.currRouteId as string
            this.getPurchaseOrderAgain()
        } else {
            this.getCustomerInfo()
        }
        this.getDistributionWayList()
    }

    // 获取配送方式数据字典
    getDistributionWayList () {
        getSyDictDataInfo({dictTypeId: 'distributionWay'}).then((res) => {
            this.distributionWayList = res.data || []
        })
    }

    handleBack () {
        this.$confirmDialog.show({
            okText: '确认',
            cancelText: '取消',
            tips: '退出后将清空已录入内容，是否确认退出?',
            onOk: () => {
                this.setSelectList([])
                return this.$router.back()
            }
        })
    }

    get getSaleAmount () {
        let amount = 0
        this.selectGoodsList.forEach(item => {
            amount += item.saleAmount
        })
        return amount
    }

    get amountSum () {
        return Number(math.mathAdd(this.totalPrice, this.params.payFreight))
    }

    getPurchaseOrderAgain () {
        const obj = {
            companyId: this.companyId,
            orderId: this.orderId,
            currRouteId: this.currRouteId
        }
        purchaseOrderAgainAppApi(obj).then((res) => {
            const data = res.data || {}
            Object.assign(this.params, data)
            this.params.distributionWayDec = data.distributionWayName
            delete this.params.orderDtlList
            this.selectGoodsList = data.orderDtlList.map((item) => {
                return {
                    goodsId: item.goodsId,
                    goodsName: item.goodsName,
                    versionId: item.versionId,
                    packageId: item.setmealId,
                    packageName: item.packageName,
                    packageNameDesc: item.packageNameDesc,
                    orderPrice: item.salePrice,
                    saleAmount: item.saleAmount,
                    imageNameUrl: item.packageMainImage,
                    minimum: item.minimum,
                    maximum: item.maximum
                }
            })
            this.totalPrice = data.orderMoney
            if (data.msg && data.msg !== '') {
                this.$toast(data.msg)
            }
        })
    }

    getCustomerInfo () {
        if(!this.$checkIsEmpty(this.$route.query.customerId) && (this.params.customerId !== (this.$route.query.customerId as string))){
          /* 清除掉选择的商品列表 */
          this.selectGoodsList = []
          this.totalPrice = 0
          this.getDefaultAddress()
        }
        this.params.customerId = this.$route.query.customerId as string
        this.params.customerName = this.$route.query.customerName as string
        this.params.customerLever = this.$route.query.customerLever as string
        this.params.customerLeverName = this.$route.query
            .customerLeverName as string

        /* 重新获取地址信息 */
        // if (this.params.customerId) {
        //     this.getDefaultAddress()
        // }

      /* 清除掉选择的商品列表 */
      this.setSelectList([])
        if(this.$route.query.fromPath === '3'){
          this.clearAddressInfo()
        }
    }

    chooseCustomer () {
        this.$router.push({
            path: '/chooseCustomer',
            query: {
                customerId: this.params.customerId,
                customerName: this.params.customerName,
                customerLever: this.params.customerLever,
                customerLeverName: this.params.customerLeverName
            }
        })
    }

    chooseGoods () {
        if (!this.params.customerId) {
            return this.$toast('请先选择客户')
        }
        window.sessionStorage.setItem('toPath', this.$route.path)
        if (this.placeType === '2') {
            this.setSelectList(this.selectGoodsList)
        }
        this.$router.push({
            path: '/chooseGoods',
            query: {
                customerId: this.params.customerId
            }
        })
    }

    // 获取当前客户的默认收货地址
    getDefaultAddress () {
        getCompanyAddressInfo({companyId: this.$route.query.customerId})
            .then((res) => {
                this.clearAddressInfo()
                if (res.data.addressList && res.data.addressList.length > 0) {
                    const list = res.data.addressList.filter((item) => item.isDefault)
                    if (list && list.length > 0) {
                        const addressInfo = list[0]

                        this.params.receiveMan = addressInfo.receiveMan
                        this.params.receiveMobile = addressInfo.receiveMobile
                        this.params.receiveAddress = addressInfo.addressId
                        this.params.receiveAddressName = addressInfo.addressName
                        this.params.receiveAddressDtl = addressInfo.addressDtl
                    }
                }
            })
            .catch(() => {
                this.clearAddressInfo()
            })
    }

    /* 清除地址信息 */
    clearAddressInfo () {
        this.params.receiveMan = ''
        this.params.receiveMobile = ''
        this.params.receiveAddress = ''
        this.params.receiveAddressName = ''
        this.params.receiveAddressDtl = ''
    }

    // 调用原生enterSelectAddress方法去选择收获地址
    toSelectAddress () {
        if (!this.params.customerId) {
            return this.$toast.fail('请先选择客户')
        }
        const data = {
            customerId: this.params.customerId,
            isShowTemporary: true, // 是否展示临时地址信息 传false就是不展示，true就是展示
            title: '收货地址'
        }
        this.$bridge.callHandler('enterSelectAddress', {data}, (res) => {
            const data = !res ? {} : JSON.parse(res)
            this.params.receiveMan = data.receiveMan
            this.params.receiveMobile = data.receiveMobile
            this.params.receiveAddress = data.addressId
            this.params.receiveAddressName = data.addressName
            this.params.receiveAddressDtl = data.addressDtl
            this.params.isDefault = data.isDefault
        })
    }

    /* 获取上传附件信息 */
    getUploadInfo (data: AppendixFileDto[]) {
        this.params.orderFileList = data
    }

    /* 显示上传附件弹窗 */
    showUploadFunc () {
        (this.$refs.appendix as any).show({
            fileType: '6',
            orderFile:this.params.orderFileList
        })
    }

    wayConfirm (data: DictDataDto) {
        this.params.distributionWay = data.dataId
        this.params.distributionWayDec = data.dataName
        this.showWayPicker = false
    }

    onConfirmData () {
        console.log(this.$refs.timeDate)
        const date = (this.$refs.timeDate as any).currentDate
        this.params.deliveryDate = dayjs(date).format('YYYY-MM-DD')
        this.showCalendar = false
    }

    clearTimeData () {
        // (this.$refs.timeDate as any).reset()
        this.params.deliveryDate = ''
        this.showCalendar = false
    }

    /**
     * 格式化金额 仅可录入数字，最少为0.00，最大为99999999.99
     * @param value
     */
    formatterMoney (value) {
        if (value) {
            value = Number(value) > 99999999.99 ? '99999999.99' : value
        } else {
            value = '0'
        }
        return value
            .replace(/0*(\d+)/, '$1')
            .replace(/[^0-9.]/g, '')
            .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    }

    editAmount () {
        this.isEdit = true
        this.$nextTick(() => {
            (this.$refs.payFreight as any).focus()
        })
    }

    submitOrder () {
        if (!this.params.customerId) {
            return this.$toast.fail('请先选择客户')
        }

        if (!this.params.receiveAddress) {
            return this.$toast.fail('请选择收货地址')
        }

        if (!this.selectGoodsList || this.selectGoodsList.length <= 0) {
            return this.$toast.fail('请选择商品')
        } else {
            this.params.purchaseOrderDtlList = this.selectGoodsList.map((item) => {
                return {
                    versionId: item.versionId,
                    goodsId: item.goodsId,
                    setmealId: item.packageId,
                    saleAmount: item.saleAmount
                }
            })
        }
        if (!this.params.distributionWay) {
            return this.$toast.fail('请选择配送方式')
        }

        if (!this.params.payFreight && this.params.payFreight !== 0) {
            return this.$toast.fail('请输入运费')
        }

        if(this.params.orderFileList&&this.params.orderFileList.length>0){
            this.params.orderFileList.map(item=>{
              delete item.createUser
            })
        }
        addPurchaseOrder(this.params)
            .then(() => {
                this.$toast({
                    message: '代客下单成功',
                    duration: 1000,
                    onClose: () => {
                        // window.sessionStorage.setItem('isRefresh', '1')
                        // this.$router.replace('/salesOrderList')
                        // 需求2.0 BUG26711 要求代客下单成功之后回到首页
                      this.$goHomeBack()
                    }
                })
            })
            .catch(() => {})
    }
}
